export const API_BASE: string = (import.meta as any).env?.VITE_API_URL || 'https://api.webmix-it.de'


